/**
 * jQuery Disable GoogleAnalytics
 * @category jQuery plugin
*/

// Set to the same value as the web property used on the site
var gaProperty = 'XXXXXXXXXX';
// Disable tracking if the opt-out cookie exists.
var disableStr = 'ga-disable-' + gaProperty;
if (document.cookie.indexOf(disableStr + '=true') > -1) {
    window[disableStr] = true;
}
// Opt-out function
(function ( $ ) {
    $.fn.gaOptout=function() {
        $(this).click(function(e){
            e.preventDefault();        
            document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
            window[disableStr] = true;
            alert($(this).attr('title'));
        });
    }
}( jQuery ));

// Opt-in function
(function ( $ ) {
    $.fn.gaOptin=function() {
        $(this).click(function(e){
            e.preventDefault();        
            document.cookie = disableStr + '=false';
            window[disableStr] = false;
            alert($(this).attr('title'));
        });
    }
}( jQuery ));

/**
 * jQuery get_iFrame
 * @author Christoph Roderer
 * @version 1.0
 * @date Juni, 2018
 * @category jQuery plugin
*/

(function ($) {
    $.fn.get_iFrame=function()
    {
        $(this).each(function(){
            var data_src = $(this).attr('data-src');
            $(this).attr('src', data_src);
        });
    }
}( jQuery ));

/**
 * jQuery loadImages
 * @author Christoph Roderer
 * @version 1.0
 * @date Juni, 2018
 * @category jQuery plugin
*/

function loadImages(getFunction)
{
    var preLoadImg = 0;
    var preLoadImgLength = $(document).find('img').length;
    $(document).find('img').each(function(){
        var img = new Image();
        img.onload = function() {
            preLoadImg++;
            if(preLoadImg == preLoadImgLength){
                $('iframe').get_iFrame();
            }
        }
        img.src = $(this).attr('src');
    });
}



/**
 * jQuery Page Form
 * @author Christoph Roderer
 * @version 1.0
 * @date Juni 09, 2017
 * @category jQuery plugin
*/
(function ( $ ) {
$.fn.pageForm=function (options) {

    var defaultSettings = {
        plugin:             true,
        debug:              false,
        prev:               "Zurück", 
        next:               "Weiter", 
        submit:             "kostenlose Anfrage stellen",
        successMsg:         "Das Formular wurde verschickt!",
        errorMsg:           "Ein Fehler ist aufgetreten.",
    }

    options = $.extend({}, defaultSettings, options);

    var formName = 'Kontaktformular';

    var $body = $("body"),
        $doc = $(document),
        pageContent = ".page-wrap";

    var elms = {};
    elms.$overlay               = $('<div class="pf-overlay"></div>');
    elms.$content               = $('<div class="pf-content"></div>');
    elms.$process               = $('<div class="pf-progress"></div>');
    elms.$msg                   = $('<div class="pf-msg"></div>');
    elms.$success               = $('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><g id="Ebene_1"><polyline class="pf-msg-icon" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" points="29.94,49.847 43.263,63.629 70.06,36.372"/><circle class="pf-circle" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" cx="50" cy="50" r="43.622"/></g><g id="Ebene_2"></g></svg>');
    elms.$error                 = $('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><g id="Ebene_1"><circle class="pf-circle" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" cx="50" cy="50" r="43.622"/><line class="pf-msg-icon" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" x1="34.498" y1="34.498" x2="65.502" y2="65.502"/><line class="pf-msg-icon" fill="none" stroke="#000000" stroke-width="2" stroke-miterlimit="10" x1="34.498" y1="65.502" x2="65.502" y2="34.498"/></g><g id="Ebene_2"></g></svg>');
    elms.$minimize              = $('<div class="pf-nav-btn pf-minimize"><span>Minimieren &amp; später fortführen</span></div>');
    elms.$close                 = $('<div class="pf-nav-btn pf-close"><span>Schließen - Eingaben werden verworfen</span></div>');
 
    var PFprogress = function(total, step){
        var progress = step/total*100;
        $('.pf-progress').width(progress+'%');
            
    }

    var PFnavigation = function(originalSubmitText){
        var countFieldset = $('.pf-content').find('fieldset:not(.pf-nav, .hidden)').length;

        $('.pf-content').find('fieldset:not(.pf-nav, .hidden)').each(function(i){
            $(this).attr('data-pf-fieldset',i+1);
        });

        $('.pf-nav [type="submit"]').click(function(e){

            var activeFieldset = $('.pf-content fieldset.pf-field-active').attr('data-pf-fieldset');
            var countRequired = $('.pf-content fieldset.pf-field-active [required]').length;
            var countRequiredTrue = 0;
            $('.pf-content fieldset.pf-field-active [required]').each(function(){
                if(this.validity.valid){
                    countRequiredTrue += 1;
                }
                if(countRequired == countRequiredTrue){

                    if(activeFieldset < countFieldset){
                        if(activeFieldset < countFieldset - 1){
                            if($('.pf-content [type="submit"]').text() != options.next){
                                $('.pf-content [type="submit"]').text(options.next);
                            }
                        }
                        else{
                            $('[type="submit"]').text(originalSubmitText);
                        }

                        e.preventDefault();
                        $('.pf-content fieldset.pf-field-active').addClass('pf-field-prev').removeClass('pf-field-next');
                        $('.pf-content fieldset.pf-field-active').next('.pf-field-next').addClass('pf-field-active').removeClass('pf-field-next');
                        $('.pf-content fieldset.pf-field-prev').removeClass('pf-field-active');
                        ($('.pf-nav [type="reset"]').hasClass('disabled')) ? $('.pf-nav [type="reset"]').removeClass('disabled') : '';
                        PFprogress(countFieldset, activeFieldset);
                    }
                    else{

                        $('.pf-content fieldset.pf-field-active').addClass('pf-field-prev').removeClass('pf-field-next');
                        $('.pf-content fieldset.pf-field-active').removeClass('pf-field-active');

                        if(options.submit != ""){
                            $('.pf-content [type="submit"]').text(originalSubmitText);
                        }
                        PFprogress(countFieldset, activeFieldset);

                        e.preventDefault();

                        var formData = {};

                        $('.pf-content input:not([type="checkbox"],[type="radio"])').each(function(){
                            var formElement = $(this).attr('name');   // FORM ELEMENTS WEITER MACHEN - PUSH TO OBJECT 
                            $.extend(formData, {
                                [$(this).attr('name')] : $(this).val()
                            });
                        });
                        $('.pf-content input[type="radio"]:checked').each(function(){
                            var formElement = $(this).attr('name');   // FORM ELEMENTS WEITER MACHEN - PUSH TO OBJECT 
                            $.extend(formData, {
                                [$(this).attr('name')] : $(this).val()
                            });
                        });
                        $('.pf-content input[type="checkbox"]').each(function(){
                            var formElement = $(this).attr('name');   // FORM ELEMENTS WEITER MACHEN - PUSH TO OBJECT 
                            $.extend(formData, {
                                [$(this).attr('name')] : ($(this).prop('checked')) ? $(this).val() : 'Nein'
                            });
                        });
                        $('.pf-content select').each(function(){
                            var formElement = $(this).attr('name');   // FORM ELEMENTS WEITER MACHEN - PUSH TO OBJECT 
                            $.extend(formData, {
                                [$(this).attr('name')] : $(this).find('option:selected').val()
                            });
                        });
                        $('.pf-content textarea').each(function(){
                            var formElement = $(this).attr('name');   // FORM ELEMENTS WEITER MACHEN - PUSH TO OBJECT 
                            $.extend(formData, {
                                [$(this).attr('name')] : $(this).text()
                            });
                        });

                        // if(options.debug) console.log(formData);

                        $.ajax({
                            type        : 'POST', // define the type of HTTP verb we want to use (POST for our form)
                            url         : $('.pf-content form').attr('action'), // the url where we want to POST
                            data        : formData, // our data object
                            // dataType    : 'php', // what type of data do we expect back from the server
                            encode : true

                        })
                        .success(function(data){
                            if(options.debug) console.log('Client - success');
                            var $html = $(document.createElement("html"));
                            $html[0].innerHTML = data;

                            var formInfo = $html.find('h1').attr('class');

                            $('.pf-content form').addClass('pf-form-off');

                            $('.pf-content .pf-minimize').remove();

                            if($html.find('h1').text().search("Das Formular wurde verschickt!") > -1){
                                elms.$msg.append(elms.$success);
                                elms.$msg.append(options.successMsg);
                                $('.pf-content').append(elms.$msg);
                                $('.pf-msg').addClass('pf-success');
                                if(options.debug) console.log('Form success');

                                setTimeout(function(){
                                    $('.pf-msg').addClass('pf-msg-open');
                                },500);
                            }
                            else{
                                elms.$msg.append(elms.$error);
                                elms.$msg.append(options.errorMsg);
                                $('.pf-content').append(elms.$msg);
                                $('.pf-msg').addClass('pf-error');
                                if(options.debug) console.log('Form failed');

                                setTimeout(function(){
                                    $('.pf-msg').addClass('pf-msg-open');
                                },500);
                            }
                        })
                        .fail(function(data){
                            console.log('Client - failed');
                        });
                    }
                }
            });
        });
        $('.pf-nav [type="reset"]').click(function(e){
            e.preventDefault();
            var activeFieldset = $('.pf-content fieldset.pf-field-active').attr('data-pf-fieldset')-2;

            if(!$('.pf-content fieldset[data-pf-fieldset="1"]').hasClass('pf-field-active')){
                $('.pf-content fieldset.pf-field-active').addClass('pf-field-next');
                $('.pf-content fieldset.pf-field-active').prev('fieldset').addClass('pf-field-active').removeClass('pf-field-prev');
                $('.pf-content fieldset.pf-field-next').removeClass('pf-field-active');

                if(!$('.pf-content fieldset[data-pf-fieldset="1"]').hasClass('pf-field-active')){
                    $(this).removeClass('disabled');
                }
                else{
                    $('.pf-content [type="reset"]').addClass('disabled');
                }
                if($('.pf-content [type="submit"]').text() != options.next){
                    $('.pf-content [type="submit"]').text(options.next);
                }
                PFprogress(countFieldset, activeFieldset);
            }
        });
    }

    var formStorage = function(formName){        
        if (typeof(Storage) !== "undefined") {
            $('.pf-content [type="radio"]').click(function(){
                var radioName = $(this).attr('name');
                $('input[name="'+radioName+'"]').each(function(){                    
                    ($(this).prop('checked')) ? $(this).attr('checked', true) : $(this).attr('checked', false);
                });
                sessionStorage.setItem(formName, $('.pf-content').html());
            });
            $('.pf-content [type="checkbox"]').click(function(){
                ($(this).prop('checked')) ? $(this).attr('checked', true) : $(this).attr('checked', false);
                sessionStorage.setItem(formName, $('.pf-content').html());
            });
            $('.pf-content input:not([type="checkbox"],[type="radio"])').focusout(function(){
                $(this).attr('value', $(this).val());
                sessionStorage.setItem(formName, $('.pf-content').html());
            });
            $('.pf-content textarea').focusout(function(){
                $(this).text($(this).val());
                sessionStorage.setItem(formName, $('.pf-content').html());
            });
            $('.pf-content select').click(function(){
                $(this).find('option').each(function(){
                    ($(this).prop('selected')) ? $(this).attr('selected', true) : $(this).attr('selected', false);
                });
                sessionStorage.setItem(formName, $('.pf-content').html());
            });

        }
    }
    
    var getPF = function(href) {

        var link = href;

        if(options.debug) console.log('Link: '+link);

        if(sessionStorage.getItem(formName)){

            if(options.debug) console.log('Session is set');

            $('.pf-content').html(sessionStorage.getItem(formName));

            var originalSubmitText = $('.pf-content [type="submit"]').text();
            if(options.submit != ""){
                originalSubmitText = options.submit;
            }

            if($('.pf-content [type="submit"]').text() != options.next){
                $('.pf-content [type="submit"]').text(options.next);
            }
            if($('.pf-content [type="reset"]').text() != options.prev){
                $('.pf-content [type="reset"]').text(options.prev);
            }

            PFnavigation(originalSubmitText);

            if($('.pf-content fieldset[data-pf-fieldset="1"]').hasClass('pf-field-active')){
                $('.pf-content [type="reset"]').addClass('disabled');
            }
            else{
                $('.pf-content [type="reset"]').removeClass('disabled');
            }

            formStorage(formName);

            $('.pf-close').click(function(){
                $('.pf-overlay').removeClass('pf-overlay-active');
                setTimeout(function(){
                    $('.pf-overlay').remove();
                    if(sessionStorage.getItem(formName)){
                        sessionStorage.clear(formName);
                        if(options.debug) console.log('Storage: "'+formName+'" - cleared');
                    }
                    if(options.debug) console.log('PageForm closed');
                },500);
            });
            $('.pf-minimize').click(function(){                
                $('.pf-overlay').removeClass('pf-overlay-active');
                setTimeout(function(){
                    $('.pf-overlay').remove();
                    if(options.debug) console.log('PageForm minimized');
                },500);
            });
        }
        else{

            if(options.debug) console.log('AJAX Request');

            $.ajax({
                url: href,
                context: document.body,
            })
            .error(function(statusCode, error, statusName){
                console.log('fail');
            })
            .success(function( html ) {
                if(html.indexOf(formName) > 0){

                    var $html = $(document.createElement("html"));
                    $html[0].innerHTML = html;                                                          // set HTML

                    var $form = $html.find('#'+formName).clone();                                 // receive form
                    
                    $('.pf-content').append($form);

                    var originalSubmitText = $('.pf-content [type="submit"]').text();
                    if(options.submit != ""){
                        originalSubmitText = options.submit;
                    }

                    $('.pf-content fieldset:first-child').addClass('pf-field-active');
                    $('.pf-content fieldset:not(.pf-nav, .hidden, :first-child)').addClass('pf-field-next');

                    if($('.pf-content [type="submit"]').text() != options.next){
                        $('.pf-content [type="submit"]').text(options.next);
                    }
                    if($('.pf-content [type="reset"]').text() != options.prev){
                        $('.pf-content [type="reset"]').text(options.prev);
                    }

                    PFnavigation(originalSubmitText);

                    if($('.pf-content fieldset[data-pf-fieldset="1"]').hasClass('pf-field-active')){
                        $('.pf-content [type="reset"]').addClass('disabled');
                    }
                    else{
                        $('.pf-content [type="reset"]').removeClass('disabled');                        
                    }

                    formStorage(formName);

                    $('.pf-close').click(function(){
                        $('.pf-overlay').removeClass('pf-overlay-active');
                        setTimeout(function(){
                            $('.pf-overlay').remove();
                            if(sessionStorage.getItem(formName)){
                                sessionStorage.clear(formName);
                                if(options.debug) console.log('Storage: "'+formName+'" - cleared');
                            }
                            if(options.debug) console.log('PageForm closed');
                        },500);
                    });
                    $('.pf-minimize').click(function(){
                        $('.pf-overlay').removeClass('pf-overlay-active');
                        setTimeout(function(){
                            $('.pf-overlay').remove();
                            if(options.debug) console.log('PageForm minimized');
                        },500);
                    });
                }
                else{
                    // errorPage(oldLink, '', 'Kein Content');
                }
            });
        }
    };
    if(options.plugin){

        $(this).click(function(e){
            e.preventDefault();

            var href = $(this).attr('href');

            if(options.plugin && $body.find('.pf-overlay').length == 0){                    // add Overlay
                elms.$overlay.empty();
                elms.$content.empty();
                elms.$msg = $('<div class="pf-msg"></div>');
                elms.$process = $('<div class="pf-progress"></div>');
                elms.$content.append(elms.$process);
                elms.$content.append(elms.$minimize);
                elms.$content.append(elms.$close);
                elms.$overlay.append(elms.$content);
                $body.append(elms.$overlay);
                setTimeout(function(){
                    $('.pf-overlay').addClass('pf-overlay-active');
                },50);
                getPF(href);
            }

        });
    }
}
}( jQuery ));


/**
 * jQuery backToTop
*/
(function(e){e.fn.backToTop=function(t){var t=e.extend({},e.fn.backToTop.defaultSettings,t);t.placement=this;t=e.fn.backToTop.createMarkup(t);t.button.click(function(n){n.preventDefault();e("html,body").stop().animate({scrollTop:0},t.speed)});if(e(window).scrollTop()<t.displayAt)t.button.fadeOut(0);e(window).scroll(function(n){if(e(this).scrollTop()>t.displayAt)t.button.fadeIn();else t.button.fadeOut()});return this};e.fn.backToTop.createMarkup=function(t){t.button=e('<a href="#" class="backToTop fas fa-angle-up btn dark icon-only" aria-hidden="true">'+t.text+"</a>");e(t.placement).append(t.button);return t};e.fn.backToTop.defaultSettings={text:"Zum Seitenanfang",speed:500,displayAt:200}})(jQuery);

/* Mailmask */
$.fn.noSpam=function(){at='@';return this.each(function(){e=null;$(this).find('span').replaceWith(at);e=$(this).text();$(this).attr('href','mailto:'+e);});};

/* http://fgnass.github.io/spin.js/dist/spin.min.js */
(function(t,e){if(typeof exports=="object")module.exports=e();else if(typeof define=="function"&&define.amd)define(e);else t.Spinner=e()})(this,function(){"use strict";var t=["webkit","Moz","ms","O"],e={},i;function o(t,e){var i=document.createElement(t||"div"),o;for(o in e)i[o]=e[o];return i}function n(t){for(var e=1,i=arguments.length;e<i;e++)t.appendChild(arguments[e]);return t}var r=function(){var t=o("style",{type:"text/css"});n(document.getElementsByTagName("head")[0],t);return t.sheet||t.styleSheet}();function s(t,o,n,s){var a=["opacity",o,~~(t*100),n,s].join("-"),f=.01+n/s*100,l=Math.max(1-(1-t)/o*(100-f),t),d=i.substring(0,i.indexOf("Animation")).toLowerCase(),u=d&&"-"+d+"-"||"";if(!e[a]){r.insertRule("@"+u+"keyframes "+a+"{"+"0%{opacity:"+l+"}"+f+"%{opacity:"+t+"}"+(f+.01)+"%{opacity:1}"+(f+o)%100+"%{opacity:"+t+"}"+"100%{opacity:"+l+"}"+"}",r.cssRules.length);e[a]=1}return a}function a(e,i){var o=e.style,n,r;if(o[i]!==undefined)return i;i=i.charAt(0).toUpperCase()+i.slice(1);for(r=0;r<t.length;r++){n=t[r]+i;if(o[n]!==undefined)return n}}function f(t,e){for(var i in e)t.style[a(t,i)||i]=e[i];return t}function l(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var o in i)if(t[o]===undefined)t[o]=i[o]}return t}function d(t){var e={x:t.offsetLeft,y:t.offsetTop};while(t=t.offsetParent)e.x+=t.offsetLeft,e.y+=t.offsetTop;return e}var u={lines:12,length:7,width:5,radius:10,rotate:0,corners:1,color:"#000",direction:1,speed:1,trail:100,opacity:1/4,fps:20,zIndex:2e9,className:"spinner",top:"auto",left:"auto",position:"relative"};function p(t){if(typeof this=="undefined")return new p(t);this.opts=l(t||{},p.defaults,u)}p.defaults={};l(p.prototype,{spin:function(t){this.stop();var e=this,n=e.opts,r=e.el=f(o(0,{className:n.className}),{position:n.position,width:0,zIndex:n.zIndex}),s=n.radius+n.length+n.width,a,l;if(t){t.insertBefore(r,t.firstChild||null);l=d(t);a=d(r);f(r,{left:(n.left=="auto"?l.x-a.x+(t.offsetWidth>>1):parseInt(n.left,10)+s)+"px",top:(n.top=="auto"?l.y-a.y+(t.offsetHeight>>1):parseInt(n.top,10)+s)+"px"})}r.setAttribute("role","progressbar");e.lines(r,e.opts);if(!i){var u=0,p=(n.lines-1)*(1-n.direction)/2,c,h=n.fps,m=h/n.speed,y=(1-n.opacity)/(m*n.trail/100),g=m/n.lines;(function v(){u++;for(var t=0;t<n.lines;t++){c=Math.max(1-(u+(n.lines-t)*g)%m*y,n.opacity);e.opacity(r,t*n.direction+p,c,n)}e.timeout=e.el&&setTimeout(v,~~(1e3/h))})()}return e},stop:function(){var t=this.el;if(t){clearTimeout(this.timeout);if(t.parentNode)t.parentNode.removeChild(t);this.el=undefined}return this},lines:function(t,e){var r=0,a=(e.lines-1)*(1-e.direction)/2,l;function d(t,i){return f(o(),{position:"absolute",width:e.length+e.width+"px",height:e.width+"px",background:t,boxShadow:i,transformOrigin:"left",transform:"rotate("+~~(360/e.lines*r+e.rotate)+"deg) translate("+e.radius+"px"+",0)",borderRadius:(e.corners*e.width>>1)+"px"})}for(;r<e.lines;r++){l=f(o(),{position:"absolute",top:1+~(e.width/2)+"px",transform:e.hwaccel?"translate3d(0,0,0)":"",opacity:e.opacity,animation:i&&s(e.opacity,e.trail,a+r*e.direction,e.lines)+" "+1/e.speed+"s linear infinite"});if(e.shadow)n(l,f(d("#000","0 0 4px "+"#000"),{top:2+"px"}));n(t,n(l,d(e.color,"0 0 1px rgba(0,0,0,.1)")))}return t},opacity:function(t,e,i){if(e<t.childNodes.length)t.childNodes[e].style.opacity=i}});function c(){function t(t,e){return o("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',e)}r.addRule(".spin-vml","behavior:url(#default#VML)");p.prototype.lines=function(e,i){var o=i.length+i.width,r=2*o;function s(){return f(t("group",{coordsize:r+" "+r,coordorigin:-o+" "+-o}),{width:r,height:r})}var a=-(i.width+i.length)*2+"px",l=f(s(),{position:"absolute",top:a,left:a}),d;function u(e,r,a){n(l,n(f(s(),{rotation:360/i.lines*e+"deg",left:~~r}),n(f(t("roundrect",{arcsize:i.corners}),{width:o,height:i.width,left:i.radius,top:-i.width>>1,filter:a}),t("fill",{color:i.color,opacity:i.opacity}),t("stroke",{opacity:0}))))}if(i.shadow)for(d=1;d<=i.lines;d++)u(d,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(d=1;d<=i.lines;d++)u(d);return n(e,l)};p.prototype.opacity=function(t,e,i,o){var n=t.firstChild;o=o.shadow&&o.lines||0;if(n&&e+o<n.childNodes.length){n=n.childNodes[e+o];n=n&&n.firstChild;n=n&&n.firstChild;if(n)n.opacity=i}}}var h=f(o("group"),{behavior:"url(#default#VML)"});if(!a(h,"transform")&&h.adj)c();else i=a(h,"animation");return p});
/*
 * Lightcase - jQuery Plugin
 * The smart and flexible Lightbox Plugin.
 *
 * @author      Cornel Boppart <cornel@bopp-art.com>
 * @copyright   Author
 *
 * @version     2.3.4 (29/12/2015)
 */

!function(a){"use strict";var b={cache:{},support:{},objects:{},init:function(b){return this.each(function(){a(this).unbind("click.lightcase").bind("click.lightcase",function(c){c.preventDefault(),a(this).lightcase("start",b)})})},start:function(c){b.origin=lightcase.origin=this,b.settings=lightcase.settings=a.extend(!0,{idPrefix:"lightcase-",classPrefix:"lightcase-",attrPrefix:"lc-",transition:"elastic",transitionIn:null,transitionOut:null,cssTransitions:!0,speedIn:250,speedOut:250,maxWidth:800,maxHeight:500,forceWidth:!1,forceHeight:!1,liveResize:!0,fullScreenModeForMobile:!0,mobileMatchExpression:/(iphone|ipod|ipad|android|blackberry|symbian)/,disableShrink:!1,shrinkFactor:.75,overlayOpacity:.9,slideshow:!1,timeout:5e3,swipe:!0,useKeys:!0,useCategories:!0,navigateEndless:!0,closeOnOverlayClick:!0,title:null,caption:null,showTitle:!0,showCaption:!0,showSequenceInfo:!0,inline:{width:"auto",height:"auto"},ajax:{width:"auto",height:"auto",type:"get",dataType:"html",data:{}},iframe:{width:800,height:500,frameborder:0},flash:{width:400,height:205,wmode:"transparent"},video:{width:400,height:225,poster:"",preload:"auto",controls:!0,autobuffer:!0,autoplay:!0,loop:!1},attr:"data-rel",href:null,type:null,typeMapping:{image:"jpg,jpeg,gif,png,bmp",flash:"swf",video:"mp4,mov,ogv,ogg,webm",iframe:"html,php",ajax:"json,txt",inline:"#"},errorMessage:function(){return'<p class="'+b.settings.classPrefix+'error">'+b.settings.labels.errorMessage+"</p>"},labels:{errorMessage:"Source could not be found...","sequenceInfo.of":" of ",close:"Close","navigator.prev":"Prev","navigator.next":"Next","navigator.play":"Play","navigator.pause":"Pause"},markup:function(){a("body").append(b.objects.overlay=a('<div id="'+b.settings.idPrefix+'overlay"></div>'),b.objects.loading=a('<div id="'+b.settings.idPrefix+'loading" class="'+b.settings.classPrefix+'icon-spin"></div>'),b.objects.Case=a('<div id="'+b.settings.idPrefix+'case" aria-hidden="true" role="dialog"></div>')),b.objects.Case.after(b.objects.nav=a('<div id="'+b.settings.idPrefix+'nav"></div>')),b.objects.nav.append(b.objects.close=a('<a href="#" class="'+b.settings.classPrefix+'icon-close"><span>'+b.settings.labels.close+"</span></a>"),b.objects.prev=a('<a href="#" class="'+b.settings.classPrefix+'icon-prev"><span>'+b.settings.labels["navigator.prev"]+"</span></a>").hide(),b.objects.next=a('<a href="#" class="'+b.settings.classPrefix+'icon-next"><span>'+b.settings.labels["navigator.next"]+"</span></a>").hide(),b.objects.play=a('<a href="#" class="'+b.settings.classPrefix+'icon-play"><span>'+b.settings.labels["navigator.play"]+"</span></a>").hide(),b.objects.pause=a('<a href="#" class="'+b.settings.classPrefix+'icon-pause"><span>'+b.settings.labels["navigator.pause"]+"</span></a>").hide()),b.objects.Case.append(b.objects.content=a('<div id="'+b.settings.idPrefix+'content"></div>'),b.objects.info=a('<div id="'+b.settings.idPrefix+'info"></div>')),b.objects.content.append(b.objects.contentInner=a('<div class="'+b.settings.classPrefix+'contentInner"></div>')),b.objects.info.append(b.objects.sequenceInfo=a('<div id="'+b.settings.idPrefix+'sequenceInfo"></div>'),b.objects.title=a('<h4 id="'+b.settings.idPrefix+'title"></h4>'),b.objects.caption=a('<p id="'+b.settings.idPrefix+'caption"></p>'))},onInit:{},onStart:{},onFinish:{},onClose:{},onCleanup:{}},c),b._callHooks(b.settings.onInit),b.objectData=b._setObjectData(this),b._cacheScrollPosition(),b._watchScrollInteraction(),b._addElements(),b._open(),b.dimensions=b.getViewportDimensions()},get:function(a){return b.objects[a]},getObjectData:function(){return b.objectData},_setObjectData:function(c){var d=a(c),e={title:b.settings.title||d.attr(b._prefixAttributeName("title"))||d.attr("title"),caption:b.settings.caption||d.attr(b._prefixAttributeName("caption"))||d.children("img").attr("alt"),url:b._determineUrl(),requestType:b.settings.ajax.type,requestData:b.settings.ajax.data,requestDataType:b.settings.ajax.dataType,rel:d.attr(b._determineAttributeSelector()),type:b.settings.type||b._verifyDataType(b._determineUrl()),isPartOfSequence:b._isPartOfSequence(d.attr(b.settings.attr),":"),isPartOfSequenceWithSlideshow:b._isPartOfSequence(d.attr(b.settings.attr),":slideshow"),currentIndex:a(b._determineAttributeSelector()).index(d),sequenceLength:a(b._determineAttributeSelector()).length};return e.sequenceInfo=e.currentIndex+1+b.settings.labels["sequenceInfo.of"]+e.sequenceLength,e.prevIndex=e.currentIndex-1,e.nextIndex=e.currentIndex+1,e},_prefixAttributeName:function(a){return"data-"+b.settings.attrPrefix+a},_determineLinkTarget:function(){return b.settings.href||a(b.origin).attr(b._prefixAttributeName("href"))||a(b.origin).attr("href")},_determineAttributeSelector:function(){var c=a(b.origin),d="";if("undefined"!=typeof b.cache.selector)d=b.cache.selector;else if(b.settings.useCategories===!0&&c.attr(b._prefixAttributeName("categories"))){var e=c.attr(b._prefixAttributeName("categories")).split(" ");a.each(e,function(a,c){a>0&&(d+=","),d+="["+b._prefixAttributeName("categories")+'~="'+c+'"]'})}else d="["+b.settings.attr+'="'+c.attr(b.settings.attr)+'"]';return b.cache.selector=d,d},_determineUrl:function(){var f,c=b._verifyDataUrl(b._determineLinkTarget()),d=0,e=0;return a.each(c,function(a,c){b._devicePixelRatio()>=c.density&&c.density>=e&&b._matchMedia()("screen and (min-width:"+c.width+"px)")&&c.width>=d&&(d=c.width,e=c.density,f=c.url)}),f},_normalizeUrl:function(a){var b=/^\d+$/;return a.split(",").map(function(a){var c={width:0,density:0};return a.trim().split(/\s+/).forEach(function(a,d){if(0===d)return c.url=a;var e=a.substring(0,a.length-1),f=a[a.length-1],g=parseInt(e,10),h=parseFloat(e);"w"===f&&b.test(e)?c.width=g:"h"===f&&b.test(e)?c.height=g:"x"!==f||isNaN(h)||(c.density=h)}),c})},_isPartOfSequence:function(c,d){var e=a("["+b.settings.attr+'="'+c+'"]'),f=new RegExp(d);return f.test(c)&&e.length>1},isSlideshowEnabled:function(){return b.objectData.isPartOfSequence&&(b.settings.slideshow===!0||b.objectData.isPartOfSequenceWithSlideshow===!0)},_loadContent:function(){b.cache.originalObject&&b._restoreObject(),b._createObject()},_createObject:function(){var c;switch(b.objectData.type){case"image":c=a(new Image),c.attr({src:b.objectData.url,alt:b.objectData.title});break;case"inline":c=a('<div class="'+b.settings.classPrefix+'inlineWrap"></div>'),c.html(b._cloneObject(a(b.objectData.url))),a.each(b.settings.inline,function(a,d){c.attr(b._prefixAttributeName(a),d)});break;case"ajax":c=a('<div class="'+b.settings.classPrefix+'inlineWrap"></div>'),a.each(b.settings.ajax,function(a,d){"data"!==a&&c.attr(b._prefixAttributeName(a),d)});break;case"flash":c=a('<embed src="'+b.objectData.url+'" type="application/x-shockwave-flash"></embed>'),a.each(b.settings.flash,function(a,b){c.attr(a,b)});break;case"video":c=a("<video></video>"),c.attr("src",b.objectData.url),a.each(b.settings.video,function(a,b){c.attr(a,b)});break;default:c=a("<iframe></iframe>"),c.attr({src:b.objectData.url}),a.each(b.settings.iframe,function(a,b){c.attr(a,b)})}b._addObject(c),b._loadObject(c)},_addObject:function(a){b.objects.contentInner.html(a),b._loading("start"),b._callHooks(b.settings.onStart),b.settings.showSequenceInfo===!0&&b.objectData.isPartOfSequence?(b.objects.sequenceInfo.html(b.objectData.sequenceInfo),b.objects.sequenceInfo.show()):(b.objects.sequenceInfo.empty(),b.objects.sequenceInfo.hide()),b.settings.showTitle===!0&&void 0!==b.objectData.title&&""!==b.objectData.title?(b.objects.title.html(b.objectData.title),b.objects.title.show()):(b.objects.title.empty(),b.objects.title.hide()),b.settings.showCaption===!0&&void 0!==b.objectData.caption&&""!==b.objectData.caption?(b.objects.caption.html(b.objectData.caption),b.objects.caption.show()):(b.objects.caption.empty(),b.objects.caption.hide())},_loadObject:function(c){switch(b.objectData.type){case"inline":a(b.objectData.url)?b._showContent(c):b.error();break;case"ajax":a.ajax(a.extend({},b.settings.ajax,{url:b.objectData.url,type:b.objectData.requestType,dataType:b.objectData.requestDataType,data:b.objectData.requestData,success:function(a,d,e){"json"===b.objectData.requestDataType?b.objectData.data=a:c.html(a),b._showContent(c)},error:function(a,c,d){b.error()}}));break;case"flash":b._showContent(c);break;case"video":"function"==typeof c.get(0).canPlayType||0===b.objects.Case.find("video").length?b._showContent(c):b.error();break;default:b.objectData.url?(c.load(function(){b._showContent(c)}),c.error(function(){b.error()})):b.error()}},error:function(){b.objectData.type="error";var c=a('<div class="'+b.settings.classPrefix+'inlineWrap"></div>');c.html(b.settings.errorMessage),b.objects.contentInner.html(c),b._showContent(b.objects.contentInner)},_calculateDimensions:function(a){b._cleanupDimensions();var c={objectWidth:a.attr("width")?a.attr("width"):a.attr(b._prefixAttributeName("width")),objectHeight:a.attr("height")?a.attr("height"):a.attr(b._prefixAttributeName("height"))};if(!b.settings.disableShrink)switch(c.maxWidth=parseInt(b.dimensions.windowWidth*b.settings.shrinkFactor),c.maxHeight=parseInt(b.dimensions.windowHeight*b.settings.shrinkFactor),c.maxWidth>b.settings.maxWidth&&(c.maxWidth=b.settings.maxWidth),c.maxHeight>b.settings.maxHeight&&(c.maxHeight=b.settings.maxHeight),c.differenceWidthAsPercent=parseInt(100/c.maxWidth*c.objectWidth),c.differenceHeightAsPercent=parseInt(100/c.maxHeight*c.objectHeight),b.objectData.type){case"image":case"flash":case"video":c.differenceWidthAsPercent>100&&c.differenceWidthAsPercent>c.differenceHeightAsPercent&&(c.objectWidth=c.maxWidth,c.objectHeight=parseInt(c.objectHeight/c.differenceWidthAsPercent*100)),c.differenceHeightAsPercent>100&&c.differenceHeightAsPercent>c.differenceWidthAsPercent&&(c.objectWidth=parseInt(c.objectWidth/c.differenceHeightAsPercent*100),c.objectHeight=c.maxHeight),c.differenceHeightAsPercent>100&&c.differenceWidthAsPercent<c.differenceHeightAsPercent&&(c.objectWidth=parseInt(c.maxWidth/c.differenceHeightAsPercent*c.differenceWidthAsPercent),c.objectHeight=c.maxHeight);break;case"error":!isNaN(c.objectWidth)&&c.objectWidth>c.maxWidth&&(c.objectWidth=c.maxWidth);break;default:(isNaN(c.objectWidth)||c.objectWidth>c.maxWidth)&&!b.settings.forceWidth&&(c.objectWidth=c.maxWidth),(isNaN(c.objectHeight)&&"auto"!==c.objectHeight||c.objectHeight>c.maxHeight)&&!b.settings.forceHeight&&(c.objectHeight=c.maxHeight)}b.settings.forceWidth?c.maxWidth=c.objectWidth:a.attr(b._prefixAttributeName("max-width"))&&(c.maxWidth=a.attr(b._prefixAttributeName("max-width"))),b.settings.forceHeight?c.maxHeight=c.objectHeight:a.attr(b._prefixAttributeName("max-height"))&&(c.maxHeight=a.attr(b._prefixAttributeName("max-height"))),b._adjustDimensions(a,c)},_adjustDimensions:function(a,c){a.css({width:c.objectWidth,height:c.objectHeight,"max-width":c.maxWidth,"max-height":c.maxHeight}),b.objects.contentInner.css({width:a.outerWidth(),height:a.outerHeight(),"max-width":"100%"}),b.objects.Case.css({width:b.objects.contentInner.outerWidth()}),b.objects.Case.css({"margin-top":parseInt(-(b.objects.Case.outerHeight()/2)),"margin-left":parseInt(-(b.objects.Case.outerWidth()/2))})},_loading:function(a){"start"===a?(b.objects.Case.addClass(b.settings.classPrefix+"loading"),b.objects.loading.show()):"end"===a&&(b.objects.Case.removeClass(b.settings.classPrefix+"loading"),b.objects.loading.hide())},getViewportDimensions:function(){return{windowWidth:a(window).innerWidth(),windowHeight:a(window).innerHeight()}},_verifyDataUrl:function(a){return!(!a||void 0===a||""===a)&&(a.indexOf("#")>-1&&(a=a.split("#"),a="#"+a[a.length-1]),b._normalizeUrl(a.toString()))},_verifyDataType:function(a){var c=b.settings.typeMapping;if(!a)return!1;for(var d in c)if(c.hasOwnProperty(d))for(var e=c[d].split(","),f=0;f<e.length;f++){var g=e[f].toLowerCase(),h=new RegExp(".("+g+")$","i"),i=a.toLowerCase().split("?")[0].substr(-5);if(h.test(i)===!0||"inline"===d&&a.indexOf(g)>-1)return d}return"iframe"},_addElements:function(){"undefined"!=typeof b.objects.Case&&a("#"+b.objects.Case.attr("id")).length||b.settings.markup()},_showContent:function(a){switch(b.objects.Case.attr(b._prefixAttributeName("type"),b.objectData.type),b.cache.object=a,b._calculateDimensions(a),b._callHooks(b.settings.onFinish),b.settings.transitionIn){case"scrollTop":case"scrollRight":case"scrollBottom":case"scrollLeft":case"scrollHorizontal":case"scrollVertical":b.transition.scroll(b.objects.Case,"in",b.settings.speedIn),b.transition.fade(b.objects.contentInner,"in",b.settings.speedIn);break;case"elastic":b.objects.Case.css("opacity")<1&&(b.transition.zoom(b.objects.Case,"in",b.settings.speedIn),b.transition.fade(b.objects.contentInner,"in",b.settings.speedIn));case"fade":case"fadeInline":b.transition.fade(b.objects.Case,"in",b.settings.speedIn),b.transition.fade(b.objects.contentInner,"in",b.settings.speedIn);break;default:b.transition.fade(b.objects.Case,"in",0)}b._loading("end"),b.isBusy=!1},_processContent:function(){switch(b.isBusy=!0,b.settings.transitionOut){case"scrollTop":case"scrollRight":case"scrollBottom":case"scrollLeft":case"scrollVertical":case"scrollHorizontal":b.objects.Case.is(":hidden")?(b.transition.fade(b.objects.Case,"out",0,0,function(){b._loadContent()}),b.transition.fade(b.objects.contentInner,"out",0)):b.transition.scroll(b.objects.Case,"out",b.settings.speedOut,function(){b._loadContent()});break;case"fade":b.objects.Case.is(":hidden")?b.transition.fade(b.objects.Case,"out",0,0,function(){b._loadContent()}):b.transition.fade(b.objects.Case,"out",b.settings.speedOut,0,function(){b._loadContent()});break;case"fadeInline":case"elastic":b.objects.Case.is(":hidden")?b.transition.fade(b.objects.Case,"out",0,0,function(){b._loadContent()}):b.transition.fade(b.objects.contentInner,"out",b.settings.speedOut,0,function(){b._loadContent()});break;default:b.transition.fade(b.objects.Case,"out",0,0,function(){b._loadContent()})}},_handleEvents:function(){b._unbindEvents(),b.objects.nav.children().not(b.objects.close).hide(),b.isSlideshowEnabled()&&(b.objects.nav.hasClass(b.settings.classPrefix+"paused")?b._stopTimeout():b._startTimeout()),b.settings.liveResize&&b._watchResizeInteraction(),b.objects.close.click(function(a){a.preventDefault(),b.close()}),b.settings.closeOnOverlayClick===!0&&b.objects.overlay.css("cursor","pointer").click(function(a){a.preventDefault(),b.close()}),b.settings.useKeys===!0&&b._addKeyEvents(),b.objectData.isPartOfSequence&&(b.objects.nav.attr(b._prefixAttributeName("ispartofsequence"),!0),b.objects.nav.data("items",b._setNavigation()),b.objects.prev.click(function(a){a.preventDefault(),b.settings.navigateEndless!==!0&&b.item.isFirst()||(b.objects.prev.unbind("click"),b.cache.action="prev",b.objects.nav.data("items").prev.click(),b.isSlideshowEnabled()&&b._stopTimeout())}),b.objects.next.click(function(a){a.preventDefault(),b.settings.navigateEndless!==!0&&b.item.isLast()||(b.objects.next.unbind("click"),b.cache.action="next",b.objects.nav.data("items").next.click(),b.isSlideshowEnabled()&&b._stopTimeout())}),b.isSlideshowEnabled()&&(b.objects.play.click(function(a){a.preventDefault(),b._startTimeout()}),b.objects.pause.click(function(a){a.preventDefault(),b._stopTimeout()})),b.settings.swipe===!0&&(a.isPlainObject(a.event.special.swipeleft)&&b.objects.Case.on("swipeleft",function(a){a.preventDefault(),b.objects.next.click(),b.isSlideshowEnabled()&&b._stopTimeout()}),a.isPlainObject(a.event.special.swiperight)&&b.objects.Case.on("swiperight",function(a){a.preventDefault(),b.objects.prev.click(),b.isSlideshowEnabled()&&b._stopTimeout()})))},_addKeyEvents:function(){a(document).bind("keyup.lightcase",function(a){if(!b.isBusy)switch(a.keyCode){case 27:b.objects.close.click();break;case 37:b.objectData.isPartOfSequence&&b.objects.prev.click();break;case 39:b.objectData.isPartOfSequence&&b.objects.next.click()}})},_startTimeout:function(){b.objects.play.hide(),b.objects.pause.show(),b.cache.action="next",b.objects.nav.removeClass(b.settings.classPrefix+"paused"),b.timeout=setTimeout(function(){b.objects.nav.data("items").next.click()},b.settings.timeout)},_stopTimeout:function(){b.objects.play.show(),b.objects.pause.hide(),b.objects.nav.addClass(b.settings.classPrefix+"paused"),clearTimeout(b.timeout)},_setNavigation:function(){var c=a(b.cache.selector||b.settings.attr),d=b.objectData.sequenceLength-1,e={prev:c.eq(b.objectData.prevIndex),next:c.eq(b.objectData.nextIndex)};return b.objectData.currentIndex>0?b.objects.prev.show():e.prevItem=c.eq(d),b.objectData.nextIndex<=d?b.objects.next.show():e.next=c.eq(0),b.settings.navigateEndless===!0&&(b.objects.prev.show(),b.objects.next.show()),e},item:{isFirst:function(){return 0===b.objectData.currentIndex},isLast:function(){return b.objectData.currentIndex===b.objectData.sequenceLength-1}},_cloneObject:function(a){var c=a.clone(),d=a.attr("id");return a.is(":hidden")?(b._cacheObjectData(a),a.attr("id",b.settings.idPrefix+"temp-"+d).empty()):c.removeAttr("id"),c.show()},isMobileDevice:function(){var a=navigator.userAgent.toLowerCase(),c=a.match(b.settings.mobileMatchExpression);return!!c},isTransitionSupported:function(){var c=a("body").get(0),d=!1,e={transition:"",WebkitTransition:"-webkit-",MozTransition:"-moz-",OTransition:"-o-",MsTransition:"-ms-"};for(var f in e)e.hasOwnProperty(f)&&f in c.style&&(b.support.transition=e[f],d=!0);return d},transition:{fade:function(a,c,d,e,f){var g="in"===c,h={},i=a.css("opacity"),j={},k=e?e:g?1:0;!b.isOpen&&g||(h.opacity=i,j.opacity=k,a.css(h).show(),b.support.transitions?(j[b.support.transition+"transition"]=d+"ms ease",setTimeout(function(){a.css(j),setTimeout(function(){a.css(b.support.transition+"transition",""),!f||!b.isOpen&&g||f()},d)},15)):(a.stop(),a.animate(j,d,f)))},scroll:function(a,c,d,e){var f="in"===c,g=f?b.settings.transitionIn:b.settings.transitionOut,h="left",i={},j=f?0:1,k=f?"-50%":"50%",l={},m=f?1:0,n=f?"50%":"-50%";if(b.isOpen||!f){switch(g){case"scrollTop":h="top";break;case"scrollRight":k=f?"150%":"50%",n=f?"50%":"150%";break;case"scrollBottom":h="top",k=f?"150%":"50%",n=f?"50%":"150%";break;case"scrollHorizontal":k=f?"150%":"50%",n=f?"50%":"-50%";break;case"scrollVertical":h="top",k=f?"-50%":"50%",n=f?"50%":"150%"}if("prev"===b.cache.action)switch(g){case"scrollHorizontal":k=f?"-50%":"50%",n=f?"50%":"150%";break;case"scrollVertical":k=f?"150%":"50%",n=f?"50%":"-50%"}i.opacity=j,i[h]=k,l.opacity=m,l[h]=n,a.css(i).show(),b.support.transitions?(l[b.support.transition+"transition"]=d+"ms ease",setTimeout(function(){a.css(l),setTimeout(function(){a.css(b.support.transition+"transition",""),!e||!b.isOpen&&f||e()},d)},15)):(a.stop(),a.animate(l,d,e))}},zoom:function(a,c,d,e){var f="in"===c,g={},h=a.css("opacity"),i=f?"scale(0.75)":"scale(1)",j={},k=f?1:0,l=f?"scale(1)":"scale(0.75)";!b.isOpen&&f||(g.opacity=h,g[b.support.transition+"transform"]=i,j.opacity=k,a.css(g).show(),b.support.transitions?(j[b.support.transition+"transform"]=l,j[b.support.transition+"transition"]=d+"ms ease",setTimeout(function(){a.css(j),setTimeout(function(){a.css(b.support.transition+"transform",""),a.css(b.support.transition+"transition",""),!e||!b.isOpen&&f||e()},d)},15)):(a.stop(),a.animate(j,d,e)))}},_callHooks:function(c){"object"==typeof c&&a.each(c,function(a,c){"function"==typeof c&&c.call(b.origin)})},_cacheObjectData:function(c){a.data(c,"cache",{id:c.attr("id"),content:c.html()}),b.cache.originalObject=c},_restoreObject:function(){var c=a('[id^="'+b.settings.idPrefix+'temp-"]');c.attr("id",a.data(b.cache.originalObject,"cache").id),c.html(a.data(b.cache.originalObject,"cache").content)},resize:function(){b.isOpen&&(b.isSlideshowEnabled()&&b._stopTimeout(),b.dimensions=b.getViewportDimensions(),b._calculateDimensions(b.cache.object))},_cacheScrollPosition:function(){var c=a(window),d=a(document),e={top:c.scrollTop(),left:c.scrollLeft()};b.cache.scrollPosition=b.cache.scrollPosition||{},d.width()>c.width()&&(b.cache.scrollPosition.left=e.left),d.height()>c.height()&&(b.cache.scrollPosition.top=e.top)},_watchResizeInteraction:function(){a(window).resize(b.resize)},_unwatchResizeInteraction:function(){a(window).off("resize",b.resize)},_watchScrollInteraction:function(){a(window).scroll(b._cacheScrollPosition)},_unwatchScrollInteraction:function(){a(window).off("scroll",b._cacheScrollPosition)},_restoreScrollPosition:function(){a(window).scrollTop(parseInt(b.cache.scrollPosition.top)).scrollLeft(parseInt(b.cache.scrollPosition.left)).resize()},_switchToFullScreenMode:function(){b.settings.shrinkFactor=1,b.settings.overlayOpacity=1,a("html").addClass(b.settings.classPrefix+"fullScreenMode")},_open:function(){switch(b.isOpen=!0,b.support.transitions=!!b.settings.cssTransitions&&b.isTransitionSupported(),b.support.mobileDevice=b.isMobileDevice(),b.support.mobileDevice&&(a("html").addClass(b.settings.classPrefix+"isMobileDevice"),b.settings.fullScreenModeForMobile&&b._switchToFullScreenMode()),b.settings.transitionIn||(b.settings.transitionIn=b.settings.transition),b.settings.transitionOut||(b.settings.transitionOut=b.settings.transition),b.settings.transitionIn){case"fade":case"fadeInline":case"elastic":case"scrollTop":case"scrollRight":case"scrollBottom":case"scrollLeft":case"scrollVertical":case"scrollHorizontal":b.objects.Case.is(":hidden")&&(b.objects.close.css("opacity",0),b.objects.overlay.css("opacity",0),b.objects.Case.css("opacity",0),b.objects.contentInner.css("opacity",0)),b.transition.fade(b.objects.overlay,"in",b.settings.speedIn,b.settings.overlayOpacity,function(){b.transition.fade(b.objects.close,"in",b.settings.speedIn),b._handleEvents(),b._processContent()});break;default:b.transition.fade(b.objects.overlay,"in",0,b.settings.overlayOpacity,function(){b.transition.fade(b.objects.close,"in",0),b._handleEvents(),b._processContent()})}a("html").addClass(b.settings.classPrefix+"open"),b.objects.Case.attr("aria-hidden","false")},close:function(){switch(b.isOpen=!1,b.isSlideshowEnabled()&&(b._stopTimeout(),b.objects.nav.removeClass(b.settings.classPrefix+"paused")),b.objects.loading.hide(),b._unbindEvents(),b._unwatchResizeInteraction(),b._unwatchScrollInteraction(),a("html").removeClass(b.settings.classPrefix+"open"),b.objects.Case.attr("aria-hidden","true"),b.objects.nav.children().hide(),b._restoreScrollPosition(),b._callHooks(b.settings.onClose),b.settings.transitionOut){case"fade":case"fadeInline":case"scrollTop":case"scrollRight":case"scrollBottom":case"scrollLeft":case"scrollHorizontal":case"scrollVertical":b.transition.fade(b.objects.Case,"out",b.settings.speedOut,0,function(){b.transition.fade(b.objects.overlay,"out",b.settings.speedOut,0,function(){b.cleanup()})});break;case"elastic":b.transition.zoom(b.objects.Case,"out",b.settings.speedOut,function(){b.transition.fade(b.objects.overlay,"out",b.settings.speedOut,0,function(){b.cleanup()})});break;default:b.cleanup()}},_unbindEvents:function(){b.objects.overlay.unbind("click"),a(document).unbind("keyup.lightcase"),b.objects.Case.unbind("swipeleft").unbind("swiperight"),b.objects.prev.unbind("click"),b.objects.next.unbind("click"),b.objects.play.unbind("click"),b.objects.pause.unbind("click"),b.objects.close.unbind("click")},_cleanupDimensions:function(){var a=b.objects.contentInner.css("opacity");b.objects.Case.css({width:"",height:"",top:"",left:"","margin-top":"","margin-left":""}),b.objects.contentInner.removeAttr("style").css("opacity",a),b.objects.contentInner.children().removeAttr("style")},cleanup:function(){b._cleanupDimensions(),b.objects.loading.hide(),b.objects.overlay.hide(),b.objects.Case.hide(),b.objects.prev.hide(),b.objects.next.hide(),b.objects.play.hide(),b.objects.pause.hide(),b.objects.Case.removeAttr(b._prefixAttributeName("type")),b.objects.nav.removeAttr(b._prefixAttributeName("ispartofsequence")),b.objects.contentInner.empty().hide(),b.objects.info.children().empty(),b.cache.originalObject&&b._restoreObject(),b._callHooks(b.settings.onCleanup),b.cache={}},_matchMedia:function(){return window.matchMedia||window.msMatchMedia},_devicePixelRatio:function(){return window.devicePixelRatio||1},_isPublicMethod:function(a){return"function"==typeof b[a]&&"_"!==a.charAt(0)},_export:function(){window.lightcase={},a.each(b,function(a){b._isPublicMethod(a)&&(lightcase[a]=b[a])})}};b._export(),a.fn.lightcase=function(c){return b._isPublicMethod(c)?b[c].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof c&&c?void a.error("Method "+c+" does not exist on jQuery.lightcase"):b.init.apply(this,arguments)}}(jQuery);

/**
 * jQuery content slideshow
 * @name showslide
*/
 (function($)
 {
    $.fn.showslide = function(params)
    {
        this.each(function(i,elm)
        {
            //Extending settings with data-attributes
            var settings = $.extend({}, $.fn.showslide.defaultSettings, $(elm).data());
            settings = $.extend({}, settings, params);
            settings.instance = $(elm);
            settings = $.fn.showslide.init(settings);
        });
        return this;
    };
    $.fn.showslide.init = function(settings)
    {
        //Extending settings with internal vars
        settings.id = 'id'+(new Date()).getTime();
        settings.cssID = settings.instance.attr('id');
        settings.items = settings.instance.children();
        settings.itemCount = settings.items.length;

        // settings.items.css({'transition-duration': settings.speed+'ms'});
        
        settings.direction = 1; // 1 = fwd | 0 = bwd
        
        settings.intid = null;
        settings.speed = parseInt(settings.speed);

        if(settings.randomize == true)
        {
            var itemarr = settings.items.toArray();

            for (var i = itemarr.length - 1; i > 0; i--) 
            {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = itemarr[i];
                itemarr[i] = itemarr[j];
                itemarr[j] = temp;
            }
            
            settings.items = $(itemarr);
            settings.instance.html(settings.items);
        }

        if(settings.group > 0)
        {
            settings.group = parseInt(settings.group);
            settings.itemClass = 12 / settings.group+'';
            settings.itemClass = settings.itemClass.replace('.', '_');
            var tmpItems = settings.items.toArray();
            var max = Math.round(parseFloat(settings.items.length / settings.group));
            for(i=0;i<=max;i++)
            {
                start = (i + i )* (settings.group/2); 
                end = start + settings.group;
                $(tmpItems.slice(start, end)).wrapAll('<div class="slide row" />').addClass('large-'+settings.itemClass+' default-'+parseInt(settings.itemClass)*2);
            }
            settings.items = settings.instance.children();
            settings.itemCount = settings.items.length;
        }

        if(settings.useCSS == false || $.fn.showslide.browserSupport('transition') == false)
        {
            settings.useCSS = false;
            settings.instance.removeClass('fade').addClass('horizontal');
            $(settings.items).each(function(i)
            {
                if(i>0) $(this).fadeOut(0);
                $(this).css({top:0,left:0});
            });
        }

        if(settings.storage == true && localStorage.getItem(settings.cssID) != null)
        {
            settings.current = settings.selection = parseInt(localStorage.getItem(settings.cssID));
        }
        else settings.current = settings.selection = settings.startAt;

        //Prepare the DOM objects
        settings.instance.attr('data-id',settings.id);
        settings.items.addClass('slide');
        $(settings.items[settings.selection]).addClass('active');
        if(settings.navigation == true && settings.itemCount > 1) $.fn.showslide.buildNavigation(settings);

        if (typeof(settings.onStart) == 'function') settings.onStart();

        //Force into stretch mode
        if(settings.stretch) $.fn.showslide.stretch(settings);
        
        //Distribute css classnames
        settings = $.fn.showslide.elmSetter(settings);

        //Starting if playing = true
        if(settings.playing==true && settings.itemCount > 1) settings.intid = setInterval(function(){$.fn.showslide.slide(settings)}, settings.interval);

        $(settings.items).bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function() { settings = $.fn.showslide.elmSetter(settings); });
    };
    $.fn.showslide.slide = function(settings, direct)
    {
        settings.isSliding = true;

        //This is setting the current/next/prev if navigation isn't used
        if(typeof(settings.next) == 'undefined' && typeof(settings.prev) == 'undefined')
        {
            switch(settings.current)
            {
                case 0:
                settings.next = (settings.direction == 1) ? 1 : settings.itemCount-1;
                settings.prev = (settings.direction == 1) ? settings.itemCount-1 : 1;
                break;
                case settings.itemCount-1:
                settings.next = (settings.direction == 1) ? 0 : settings.current-1;
                settings.prev = (settings.direction == 1) ? settings.current-1 : 0;
                break;
                default:
                settings.next = (settings.direction == 1) ? settings.current+1 : settings.current-1;
                settings.prev = (settings.direction == 1) ? settings.current-1 : settings.current+1;
                break;
            }
        }

        if(settings.useCSS)
        {
            if (settings.direction == 1)
            {
                $(settings.items[settings.next]).removeClass('right').addClass('active animate');
                $(settings.items[settings.current]).removeClass('active').addClass('left animate');
            }
            else
            {
                $(settings.items[settings.next]).removeClass('left').addClass('active animate');
                $(settings.items[settings.current]).addClass('right animate').removeClass('active');
            }
        }
        else
        {
            if (settings.direction == 1)
            {
                $(settings.items[settings.next]).addClass('active ');
                $(settings.items[settings.current]).removeClass('active');
            }
            else
            {
                $(settings.items[settings.next]).addClass('active');
                $(settings.items[settings.current]).removeClass('active');
            }
            
            $(settings.items[settings.current]).fadeOut(settings.speed, 'linear');
            $(settings.items[settings.next]).stop().fadeIn(settings.speed, 'linear', function()
            {
                settings = $.fn.showslide.elmSetter(settings);
            });
        }

        settings.current = settings.next;
        delete settings.next; delete settings.prev;

        // active state for pagination
        if(settings.navigation == true)
        {
            $(settings.controls.pagination.nodes).each(function(){$(this).removeClass('active');});
            $(settings.controls.pagination.nodes[settings.current]).addClass('active');
        }

        if(settings.storage) localStorage.setItem(settings.cssID, settings.current);

        // getting from pause back to play
        if(settings.intid == null && settings.playing) settings.intid = setInterval(function(){$.fn.showslide.slide(settings)}, settings.interval);

        return this;
    };
    $.fn.showslide.elmSetter = function(settings)
    {
        if (typeof(settings.onNext) == 'function') settings.onNext();
        settings.isSliding = false;
        if (settings.direction === 1) $(settings.items).not($(settings.items[settings.current])).removeClass('left animate').addClass('right');
        if (settings.direction === 0) $(settings.items).not($(settings.items[settings.current])).removeClass('right animate').addClass('left'); 

        return settings;
    };
    $.fn.showslide.buildNavigation = function(settings)
    {
        //capability to place the controls somewhere in the dom
        settings.navigationContainer = (settings.extraextra) ? $(settings.extraextra) : settings.instance;

        //create and add controls
        settings.controls = new Object();
        settings.controls.prevBut = $('<a class="showslidePrev showslideController">'+settings.prevText+'</a>');
        settings.controls.nextBut = $('<a class="showslideNext showslideController">'+settings.nextText+'</a>');
        var initStateText = (settings.playing) ? settings.pauseText : settings.playText;
        if(settings.hoverStop === false) settings.controls.playBut = $('<a class="showslideController showslidePlay '+settings.playing+'">'+initStateText+'</a>');
        for (var control in settings.controls) settings.navigationContainer.append(settings.controls[control]);

        //create and add pagination
        settings.controls.pagination = $('<ul class="showslideController showslideSelect" data-nav-for="'+settings.id+'"></ul>');
        if(settings.thumbnails) settings.controls.pagination.addClass('thumbnails');
        settings.navigationContainer.append(settings.controls.pagination);
        settings.controls.pagination.nodes = new Array();
        for(var i=0; i<settings.items.length;i++)
        {
            settings.controls.pagination.nodes[i] = $('<li data-slide="'+i+'">'+(i+1)+'</li>');
            settings.controls.pagination.append(settings.controls.pagination.nodes[i]);

            if(settings.thumbnails)
            {
                settings.controls.pagination.nodes[i].css({backgroundImage:'url('+$(settings.items[i]).find('img').attr('src')+')'});
            }
            settings.controls.pagination.nodes[i].click(function(e)
            {
                e.preventDefault();
                if(settings.current != $(this).attr('data-slide'))
                {
                    window.clearInterval(settings.intid);
                    settings.intid = null;
                    settings.next = $(this).data('slide');
                    settings.direction = (settings.next > settings.current) ? 1 : 0;
                    settings = $.fn.showslide.elmSetter(settings);
                    setTimeout(function(){$.fn.showslide.slide(settings);}, 50);
                }
            });
        }
        $(settings.controls.pagination.nodes[settings.selection]).addClass('active');

        //Events for the controls
        settings.controls.prevBut.click(function(e)
        {
            e.preventDefault();
            window.clearInterval(settings.intid);
            settings.intid = null;
            settings.direction = 0;
            settings = $.fn.showslide.elmSetter(settings);
            setTimeout(function(){$.fn.showslide.slide(settings);}, 50);
        });
        settings.controls.nextBut.click(function(e)
        {
            e.preventDefault();
            window.clearInterval(settings.intid);
            settings.intid = null;
            settings.direction = 1;
            settings = $.fn.showslide.elmSetter(settings);
            setTimeout(function(){$.fn.showslide.slide(settings);}, 50);
        });
        if(settings.hoverStop === true && settings.playing === true)
        {
            settings.instance.hover(function(e)
            {
                settings.intid = window.clearInterval(settings.intid);
                settings.intid = null;
                settings.playing = false;
            }, function(e)
            {
                settings.playing = true;
                settings.intid = setInterval(function(){$.fn.showslide.slide(settings)}, settings.interval);
            });
        }
        else if (typeof settings.controls.playBut != 'undefined')
        {
            settings.controls.playBut.click(function(e)
            {
                button = $(this);
                e.preventDefault();
                if(settings.playing)
                {
                    settings.intid = window.clearInterval(settings.intid);
                    settings.intid = null;

                    settings.playing = false;
                    button.removeClass('true');
                    button.html(settings.playText);
                    if (typeof(settings.onPause) == 'function') settings.onPause();
                }
                else
                {
                    settings.playing = true;
                    $.fn.showslide.slide(settings);
                    button.addClass('true');
                    button.html(settings.pauseText);
                }
            });
        }
        settings.instance.mouseover(function()
        {
            $(document).keydown(function(e)
            {
                switch(e.which)
                {
                    case 37:// left
                    settings.controls.prevBut.trigger('click');
                    break;
                    case 38:// up
                    break;
                    case 39:// right
                    settings.controls.nextBut.trigger('click');
                    break;
                    case 40:// down
                    break;
                    default: return;
                }
                e.preventDefault();
            });         
        }); 
    };
    $.fn.showslide.killControls = function(settings)
    {
        for (var key in settings.controls) 
        {
            settings.controls[key].remove();
        }
        settings.navigation = false;
    };
    $.fn.showslide.stretch = function(settings)
    {
        if(settings.stretch=='fullscreen')settings.instance.css({position:'fixed', width:'100%', height:'100%',margin:0,zIndex:0,top:0,left:0});
        if(settings.stretch)$(settings.items).find('img').css({position:'absolute'}).ruggedStretch();
    };
    $.fn.showslide.browserSupport = function(prop) 
    {
        var div = document.createElement('div'),  
        vendors = 'Khtml Ms O Moz Webkit'.split(' '),  
        len = vendors.length;  
        if (prop in div.style) return true;  
        prop = prop.replace(/^[a-z]/, function(val) 
        {  
            return val.toUpperCase();  
        });  
        while(len--) if (vendors[len] + prop in div.style) return true;    
        return false;  
    };
    $.fn.showslide.defaultSettings =
    {
        speed : 800,
        interval: 5000,
        navigation: false,
        prevText: 'previous',
        nextText: 'next',
        playText: 'play',
        pauseText: 'pause',
        extraextra: false,
        playing: true,
        useCSS: true,
        stretch: false,
        hoverStop: true,
        thumbnails: false,
        startAt: 0,
        storage: false,
        group: 0,
        randomize: false
    };
})(jQuery);

/**
 * jQuery image stretcher
 */
 (function($)
 {
    $.fn.ruggedStretch = function(settings)
    {
        var settings = $.extend({}, $.fn.ruggedStretch.defaultSettings, settings);
        settings.items = $(this);
        settings.loader = Array();

        $(window).resize(function() 
        {
            $.fn.ruggedStretch.init(settings);
        });

        $.fn.ruggedStretch.init(settings);
    };
    $.fn.ruggedStretch.init = function(settings)
    {
        $.each(settings.items, function(i,elm)
        {
            elm = $(elm);

            var objImagePreloader = new Image();

            elm.src = elm.attr('src');
            
            objImagePreloader.onload = function()
            {
                var imageWidth = objImagePreloader.width,
                imageHeight = objImagePreloader.height,
                windowWidth = elm.parent().width(),
                windowHeight = elm.parent().height(),
                verticalRatio = windowWidth / imageWidth,
                horizontalRatio = windowHeight / imageHeight,
                horizontalDiff = horizontalRatio * imageWidth,
                verticalDiff = verticalRatio * imageHeight;                 

                if(verticalDiff>windowHeight)
                {
                    elm.css({width: windowWidth+'px', height: verticalDiff+'px', left:'50%', top:'50%', marginLeft:(windowWidth/2*-1)+'px', marginTop:(verticalDiff/2*-1)+'px'});
                }
                else
                {
                    elm.css({width: horizontalDiff+'px', height: windowHeight+'px', left:'50%', top:'50%', marginLeft:(horizontalDiff/2*-1)+'px', marginTop:(windowHeight/2*-1)+'px'});
                }
                objImagePreloader.onload=function(){};
            }
            objImagePreloader.src = elm.src;

            return elm;
        });
        return settings;
    };
    $.fn.ruggedStretch.defaultSettings = {};
})(jQuery);